import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Login from "./Login";

function LoginPage() {
    return (
        <div>
            <Navbar />
            <Login />
            <Footer />
        </div>
    )
}

export default LoginPage;